<template>
  <div class="item" :class="{ 'item--home': isHomeChat }">
    <template v-if="isHomeChat">
      <div class="first_div">
        <div class="first_main">
          <div class="name_div">{{ config.name }}</div>
          <el-button
            type="primary"
            :disabled="
              $store.state.toLastKeyName === '浏览中' ||
              (config.canOperate == false &&
                $store.state.toLastKeyName !== '对话过')
            "
            icon="el-icon-edit-outline"
            size="mini"
            class="btn_div"
            @click="updateNick"
            >修改昵称</el-button
          >
          <el-button
            type="primary"
            :disabled="
              $store.state.toLastKeyName === '浏览中' ||
              (config.canOperate == false &&
                $store.state.toLastKeyName !== '对话过')
            "
            icon="el-icon-paperclip"
            size="mini"
            v-if="config.mark == null"
            class="btn_div1"
            @click="updateMark"
            >备注</el-button
          >
          <el-button
            type="primary"
            :disabled="
              $store.state.toLastKeyName === '浏览中' ||
              (config.canOperate == false &&
                $store.state.toLastKeyName !== '对话过')
            "
            icon="el-icon-paperclip"
            size="mini"
            class="btn_div"
            @click="updateMark"
            >修改备注</el-button
          >
        </div>
        <div class="first_stats">
          <div class="address" v-if="config.ipdress.length > 0">
            IP归属地：{{ getProvinceByCity(config.ipdress)}}
          </div>
          <div class="visite">累计访问次数：{{ config.number }}次</div>
          <div class="csMessage">推广账号：{{ config.aduserId }}</div>
        </div>
      </div>
      <div class="meta_row">
        <div class="tag_div">
          <div
            class="tag_item"
            v-for="(item, index) in config.tags"
            :style="{ 'background-color': '#' + item.color }"
            :key="index"
          >
            {{ item.name }}
          </div>
          <el-button
            class="add_tag"
            size="mini"
            type="text"
            :disabled="
              $store.state.toLastKeyName === '浏览中' ||
              (config.canOperate == false &&
                $store.state.toLastKeyName !== '对话过')
            "
            @click="addTagAction"
            >+ 标签</el-button
          >
        </div>
        <div class="mark_div" v-if="config.mark != null">
          备注：{{ config.mark }}
        </div>
      </div>
    </template>

    <template v-else>
      <div class="first_div first_div--legacy">
        <div class="name_div">{{ config.name }}</div>
        <el-button
          type="primary"
          :disabled="
            $store.state.toLastKeyName === '浏览中' ||
            (config.canOperate == false &&
              $store.state.toLastKeyName !== '对话过')
          "
          icon="el-icon-edit-outline"
          size="mini"
          class="btn_div"
          @click="updateNick"
          >修改昵称</el-button
        >
        <el-button
          type="primary"
          :disabled="
            $store.state.toLastKeyName === '浏览中' ||
            (config.canOperate == false &&
              $store.state.toLastKeyName !== '对话过')
          "
          icon="el-icon-paperclip"
          size="mini"
          v-if="config.mark == null && config.itype == 0"
          class="btn_div1"
          @click="updateMark"
          >备注</el-button
        >
        <el-button
          type="primary"
          :disabled="
            $store.state.toLastKeyName === '浏览中' ||
            (config.canOperate == false &&
              $store.state.toLastKeyName !== '对话过')
          "
          icon="el-icon-paperclip"
          size="mini"
          class="btn_div"
          @click="updateMark"
          >修改备注</el-button
        >
        <el-button
          v-if="config.itype == 1"
          type="primary"
          icon="el-icon-document-copy"
          size="mini"
          class="btn_div"
          @click="copyAlltext"
          >全文复制</el-button
        >
        <el-button
          v-if="config.itype == 1"
          type="primary"
          icon="el-icon-document-copy"
          size="mini"
          class="btn_div"
          @click="trackPopup"
          >访客轨迹</el-button
        >
        <el-button
          v-if="config.itype == 1"
          type="primary"
          icon="el-icon-document-copy"
          size="mini"
          class="btn_div"
          @click="copyTraces"
          >复制轨迹</el-button
        >
        <el-button
          v-if="config.itype == 1"
          type="primary"
          icon="el-icon-cpu"
          size="mini"
          class="btn_div"
          @click="aiAnalysis"
          >AI分析</el-button
        >
      </div>
      <div class="mark_div mark_div--legacy" v-if="config.mark != null">
        备注：{{ config.mark }}
      </div>
      <div class="tag_div tag_div--legacy">
        <div
          class="tag_item"
          v-for="(item, index) in config.tags"
          :style="{ 'background-color': '#' + item.color }"
          :key="index"
        >
          {{ item.name }}
        </div>
        <el-button
          class="add_tag"
          size="mini"
          type="text"
          :disabled="
            $store.state.toLastKeyName === '浏览中' ||
            (config.canOperate == false &&
              $store.state.toLastKeyName !== '对话过')
          "
          v-if="config.itype == 0"
          @click="addTagAction"
          >+ 标签</el-button
        >
        <el-button
          class="add_tag"
          size="mini"
          type="text"
          :disabled="config.canOperate == false"
          @click="addTagAction"
          v-if="config.itype == 1"
          >+ 标签</el-button
        >
      </div>
      <div class="other_div">
        <div class="address" v-if="config.ipdress.length > 0">
          IP归属地：{{ getProvinceByCity(config.ipdress)}}
        </div>
        <div class="visite">累计访问次数：{{ config.number }}次</div>
        <div class="csMessage" v-if="config.itype == 1">
          客户ID：{{ config.cid }}
        </div>
        <div class="csMessage" v-if="config.itype == 1">
          客户来源：{{ config.source }}
        </div>
        <div class="csMessage" v-if="config.itype == 0 || config.itype == 1">
          推广账号：{{ config.aduserId }}
        </div>
      </div>
    </template>

    <!-- AI分析结果弹窗 -->
    <el-dialog
      title="AI分析结果"
      :visible.sync="aiDialogVisible"
      width="80%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      :z-index="99999"
      top="5vh"
      @close="handleDialogClose"
    >
      <template slot="title">
        <span class="el-dialog__title">AI分析结果</span>
      </template>
      <div class="ai-result-content">
        <!-- 分析中状态 -->
        <div v-if="isAnalyzing" class="analyzing-container">
          <div class="analyzing-icon">
            <i class="el-icon-loading"></i>
          </div>
          <div class="analyzing-text">AI正在分析中，请稍候...</div>
          <div class="analyzing-tip">已等待 {{ waitingSeconds }} 秒</div>
          <el-progress 
            :percentage="100" 
            :indeterminate="true"
            :show-text="false"
            class="analyzing-progress"
          ></el-progress>
        </div>
        
        <!-- 分析结果 -->
        <div v-else-if="aiResult" class="ai-analysis-sections">
          <!-- 访客信息 -->
          <div class="analysis-section">
            <h3 class="section-title">访客画像+话术分析</h3>
            <div class="section-content" v-html="formatMarkdown(aiResult.content1)"></div>
          </div>
          
          <!-- 客服回复分析 -->
          <div class="analysis-section">
            <h3 class="section-title">客服回复质量分析</h3>
            <div class="cs-analysis-container">
              <div class="section-content" v-html="formatMarkdown(aiResult.content2)"></div>
              <div class="radar-chart-wrapper">
                <div id="csRadarChart" ref="csRadarChart" class="radar-chart"></div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 无结果 -->
        <div v-else class="no-result">暂无分析结果</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button 
          v-if="isAnalyzing" 
          type="warning" 
          @click="stopAnalysis" 
          size="mini"
        >中断分析</el-button>
        <el-button @click="aiDialogVisible = false; stopPolling();" size="mini">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import areaData from '../../../node_modules/china-area-data/v5/data.json';
import * as echarts from 'echarts';

export default {
  name: "JwChat-item",
  props: {
    config: {
      type: Object,
      default: () => ({
        name: "",
        ipdress: "",
        number: "4",
        tags: [],
        mark: "",
        itype: "0", //0-聊天界面引用  1-历史消息界面引用
        canOperate: Boolean, //界面元素是否可操作，false为不可，true为可以
        cid: "",
        sid: "",
        source: "",
        aduserId: "",
      }),
      required: true,
      source: "",
    },
    showTrackPopup: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isHomeChat() {
      return String(this.config.itype) === "0";
    },
  },

  data() {
    return {
      aiDialogVisible: false,
      aiResult: "",
      isAnalyzing: false, // 是否正在分析
      pollingTimer: null, // 轮询定时器
      pollingCount: 0, // 轮询次数
      waitingSeconds: 0, // 等待秒数
      waitingTimer: null, // 等待秒数计时器
      radarChart: null // 雷达图实例
    };
  },
  beforeDestroy() {
    // 组件销毁时清理定时器
    this.stopPolling();
    // 销毁图表实例
    if (this.radarChart) {
      this.radarChart.dispose();
      this.radarChart = null;
    }
    // 移除窗口大小变化监听
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    // 轨迹弹窗
    trackPopup() {
      this.$emit("changeTrackPopup", true);
    },

    addTagAction() {
      console.log("UserItem index addTagAction", this.config);
      this.$emit("addTag", this.config.tags);
    },

    updateNick() {
      console.log("UserItem index updateNick");
      this.$emit("updateNickname", this.config.name);
    },

    updateMark() {
      console.log("UserItem index updateMark");
      this.$emit("updateMarks", this.config.mark);
    },
    // 复制全文
    copyAlltext() {
      this.$emit("copyAlltext", this.config.mark);
    },
    // 复制轨迹
    copyTraces() {
      this.$emit("copyTraces", this.config.mark);
    },
    // AI分析
    async aiAnalysis() {
      try {
        // 获取sid，优先从config中获取，如果没有则从其他可能的地方获取
        let sid = this.config.sid;
        if (!sid && this.config.sessionId) {
          sid = this.config.sessionId;
        }
        if (!sid && this.$parent && this.$parent.selectItem) {
          sid = this.$parent.selectItem.sid;
        }
        
        if (!sid) {
          this.$message.error("无法获取会话ID，请重试");
          return;
        }

        // 先查询是否已有分析结果
        const checkResponse = await this.util.postRequest({
          url: "/manager/sessionToAI/aiResult",
          method: "POST",
          data: {
            cid: this.config.cid,
            sid: sid
          }
        });
        
        console.log('checkResponse.resultCode ===', checkResponse.resultCode, '类型:', typeof checkResponse.resultCode);
        console.log('checkResponse.data ===', checkResponse.data, '是否为真:', !!checkResponse.data);
        
        if (checkResponse.resultCode == "10000" && checkResponse.data) {
          // 如果有结果，直接显示
          this.aiResult = checkResponse.data;
          this.aiDialogVisible = true;
          // 关闭抽屉
          this.$emit("closeDrawer");
          // 等待DOM更新后初始化雷达图
          this.$nextTick(() => {
            this.initRadarChart();
          });
        } else {
        console.log('进入else分支 - resultCode不等于10000或data为假值')
          // 如果没有结果，先弹窗显示等待状态，然后开启AI分析
          this.isAnalyzing = true;
          this.aiResult = null;
          this.pollingCount = 0;
          this.waitingSeconds = 0;
          this.aiDialogVisible = true;
          // 关闭抽屉
          this.$emit("closeDrawer");
          // 立即开始计时
          this.startWaitingTimer();
          // 异步开启AI分析
          this.startAIAnalysis(sid);
        }
      } catch (error) {
        console.error("AI分析请求失败:", error);
        this.$message.error("网络请求失败，请重试");
      }
    },
    
    // 开启AI分析
    async startAIAnalysis(sid) {
      try {
        // 调用开启分析接口（不等待返回，立即开始轮询）
        const startResponse = await this.util.postRequest({
          url: "/manager/sessionToAI/startAIAnalysis",
          method: "POST",
          data: {
            cid: this.config.cid,
            sid: sid,
            query: this.config.query || ""
          }
        });
        
        if (startResponse.resultCode === "10000") {
          // 开启成功，开始轮询获取结果
          this.startPolling(sid);
        } else {
          // 开启失败，停止分析状态
          this.isAnalyzing = false;
          this.stopPolling();
          this.$message.error(startResponse.desc || "开启AI分析失败");
        }
      } catch (error) {
        console.error("开启AI分析失败:", error);
        this.isAnalyzing = false;
        this.stopPolling();
        this.$message.error("网络请求失败，请重试");
      }
    },
    
    // 开始等待计时器
    startWaitingTimer() {
      // 清除之前的计时器
      if (this.waitingTimer) {
        clearInterval(this.waitingTimer);
      }
      
      // 如果等待秒数未初始化，则初始化为0
      if (this.waitingSeconds === undefined || this.waitingSeconds === null) {
        this.waitingSeconds = 0;
      }
      
      // 每秒更新等待时间
      this.waitingTimer = setInterval(() => {
        this.waitingSeconds++;
      }, 1000);
    },
    
    // 开始轮询获取AI分析结果
    startPolling(sid) {
      // 清除之前的轮询定时器
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
      }
      
      // 如果等待计时器未启动，则启动它（正常情况下已经在aiAnalysis中启动了）
      if (!this.waitingTimer) {
        this.startWaitingTimer();
      }
      
      // 每3秒轮询一次
      this.pollingTimer = setInterval(async () => {
        try {
          this.pollingCount++;
          const response = await this.util.postRequest({
            url: "/manager/sessionToAI/aiResult",
            method: "POST",
            data: {
              cid: this.config.cid,
              sid: sid
            }
          });
          
          if (response.resultCode === "10000" && response.data) {
            // 获取到结果，停止轮询
            this.aiResult = response.data;
            this.isAnalyzing = false;
            this.stopPolling();
            // 等待DOM更新后初始化雷达图
            this.$nextTick(() => {
              this.initRadarChart();
            });
          }
        } catch (error) {
          console.error("轮询AI分析结果失败:", error);
          // 继续轮询，不中断
        }
      }, 3000); // 3秒
    },
    
    // 停止轮询
    stopPolling() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
      }
      if (this.waitingTimer) {
        clearInterval(this.waitingTimer);
        this.waitingTimer = null;
      }
      this.pollingCount = 0;
      this.waitingSeconds = 0;
    },
    
    // 中断AI分析
    stopAnalysis() {
      this.isAnalyzing = false;
      this.stopPolling();
      this.$message.info("已中断AI分析");
    },
    
    // 对话框关闭时清理
    handleDialogClose() {
      this.aiDialogVisible = false;
      this.stopPolling();
      // 清理图表
      if (this.radarChart) {
        window.removeEventListener('resize', this.handleResize);
      }
    },
 
    // 根据城市获取省份
    getProvinceByCity(city) {
        // 遍历省份
      for (const provinceCode in areaData['86']) {
        const province = areaData['86'][provinceCode];
        const cities = areaData[provinceCode];
        if (cities) {
          // 遍历城市
          for (const cityCode in cities) {
            const cityItem = cities[cityCode];
            const city1 = city + '市'
            if (cityItem === city || cityItem === city1){
              return province + city + '市';
            }
          }
        }
      }
      return city
    },
    // 格式化Markdown
    formatMarkdown(markdown) {
      if (!markdown) return '';
      
      // 简单的Markdown格式化
      let formatted = markdown
        // 处理所有 <b> 相关的标签（包括不完整的标签）
        // 先处理标签对：<b>xxx</b： 或 <b>xxx</b>，确保保留标签后的内容（冒号等）
        // 匹配 <b>xxx</b： 这种情况，保留 xxx 和后面的冒号
        .replace(/<b[^>]*>([^<]+?)<\/b([：:])/gi, '$1$2')  // 匹配 <b>xxx</b：，保留内容和冒号
        // 匹配 <b>xxx</b> 完整标签
        .replace(/<b[^>]*>([^<]+?)<\/b>/gi, '$1')  // 匹配 <b>xxx</b>，保留内容
        // 再处理单独的 <b> 开始标签（后面没有对应的 </b）
        .replace(/<b[^>]*>/gi, '')
        // 处理剩余的 </b 不完整标签（后面可能跟着冒号等，需要保留冒号）
        .replace(/<\/b([：:])/gi, '$1')  // 如果 </b 后面跟着冒号，只移除 </b，保留冒号
        .replace(/<\/b>/gi, '')  // 移除完整的 </b> 标签
        .replace(/<\/b\s*/gi, '')  // 移除 </b 后面跟着空格的情况
        // 去除多余的 > 符号（可能是标签残留，出现在文本后面）
        .replace(/([^：\s\n])>/g, '$1')  // 去除文本末尾的 > 符号（但保留冒号、空格、换行前的 >）
        // 处理粗体 **text** -> <strong>text</strong>
        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
        // 处理斜体 *text* -> <em>text</em>
        .replace(/\*(.*?)\*/g, '<em>$1</em>')
        // 处理换行
        .replace(/\n/g, '<br>')
        // 处理分隔线 ---
        .replace(/---/g, '<hr>');
      
      return formatted;
    },
    
    // 解析客服回复分析内容，提取评分维度
    parseCSAnalysis(csReplay) {
      if (!csReplay) return null;
      
      const result = {
        indicators: [],
        values: []
      };
      
      const foundDimensions = [];
      const foundNames = new Set(); // 用于去重
      let match;
      
      // 格式1：新格式 - 及时性：说明。   分数：100
      // 匹配模式：维度名：任意内容   分数：数字
      // 使用贪婪匹配确保能匹配到完整的维度名称（包括"精简性互动性"这样的组合名称）
      const newFormatPattern = /([^：:\n]+)[：:].*?分数[：:]\s*(\d+)/g;
      
      while ((match = newFormatPattern.exec(csReplay)) !== null) {
        let dimensionText = match[1].trim();
        // 去除HTML标签 <b>、</b>、</b 等（包括不完整的标签）
        dimensionText = dimensionText.replace(/<\/b[^>]*/gi, '')  // 先处理不完整的 </b 标签
          .replace(/<\/?b[^>]*>/gi, '')  // 再处理完整的标签
          .replace(/([^：\s\n])>/g, '$1');  // 去除多余的 > 符号
        // 排除"总分数"的情况
        if (dimensionText === '总分数' || dimensionText === '总' || dimensionText.trim() === '') {
          continue;
        }
        const score = parseInt(match[2]);
        
        // 直接使用维度名称，不进行拆分
        // 确保去除所有HTML标签（包括不完整的标签）
        const cleanDimText = dimensionText.trim();
        // 避免重复添加
        if (cleanDimText && !foundNames.has(cleanDimText)) {
          foundNames.add(cleanDimText);
          foundDimensions.push({
            name: cleanDimText,
            value: Math.min(score, 100)
          });
        }
      }
      
      // 格式2：旧格式 - 及时性：95分（说明） 或 专业度：90（说明）
      // 如果新格式没有匹配到，尝试旧格式
      if (foundDimensions.length === 0) {
        const oldFormatPattern = /([^：:\n（(]+)[：:]\s*(\d+)\s*分?[（(]/g;
        while ((match = oldFormatPattern.exec(csReplay)) !== null) {
          let dimensionText = match[1].trim();
          // 去除HTML标签 <b>、</b>、</b 等（包括不完整的标签）
          dimensionText = dimensionText.replace(/<\/?b[^>]*>/gi, '').replace(/<\/b(?=\s|$)/gi, '').trim();
          const score = parseInt(match[2]);
          
          // 直接使用维度名称，不进行关键词映射
          if (dimensionText && !foundNames.has(dimensionText)) {
            foundNames.add(dimensionText);
            foundDimensions.push({
              name: dimensionText,
              value: Math.min(score, 100)
            });
          }
        }
      }
      
      // 如果没有找到维度，使用默认维度
      if (foundDimensions.length === 0) {
        foundDimensions.push(
          { name: '及时性', value: 85 },
          { name: '专业度', value: 90 },
          { name: '友好度', value: 88 },
          { name: '针对性', value: 82 },
          { name: '互动性', value: 80 }
        );
      }
      
      // 构建雷达图数据
      foundDimensions.forEach(dim => {
        result.indicators.push({ name: dim.name, max: 100 });
        result.values.push(dim.value);
      });
      
      return result;
    },
    
    // 初始化雷达图
    initRadarChart() {
      if (!this.aiResult || !this.aiResult.content2) return;
      
      const chartDom = this.$refs.csRadarChart;
      if (!chartDom) return;
      
      // 销毁旧的图表实例
      if (this.radarChart) {
        this.radarChart.dispose();
      }
      
      // 解析数据
      const chartData = this.parseCSAnalysis(this.aiResult.content2);
      if (!chartData || chartData.indicators.length === 0) return;
      
      // 初始化图表
      this.radarChart = echarts.init(chartDom);
      
      const option = {
        title: {
          text: '客服表现评分',
          left: 'center',
          top: 10,
          textStyle: {
            fontSize: 14,
            fontWeight: 'normal',
            color: '#303133'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: (params) => {
            let result = '<div style="padding: 5px;">';
            params.value.forEach((value, index) => {
              result += `${chartData.indicators[index].name}: ${value}分<br/>`;
            });
            result += '</div>';
            return result;
          }
        },
        radar: {
          indicator: chartData.indicators,
          radius: '65%',
          center: ['50%', '55%'],
          splitNumber: 4,
          name: {
            textStyle: {
              color: '#606266',
              fontSize: 12
            }
          },
          splitLine: {
            lineStyle: {
              color: '#e4e7ed'
            }
          },
          splitArea: {
            show: true,
            areaStyle: {
              color: ['rgba(64, 158, 255, 0.1)', 'rgba(64, 158, 255, 0.05)']
            }
          },
          axisLine: {
            lineStyle: {
              color: '#e4e7ed'
            }
          }
        },
        series: [{
          type: 'radar',
          data: [{
            value: chartData.values,
            name: '客服评分',
            areaStyle: {
              color: 'rgba(64, 158, 255, 0.3)'
            },
            lineStyle: {
              color: '#409eff',
              width: 2
            },
            itemStyle: {
              color: '#409eff',
              borderColor: '#409eff',
              borderWidth: 2
            }
          }],
          label: {
            show: true,
            formatter: (params) => {
              return params.value;
            },
            color: '#409eff',
            fontSize: 11,
            fontWeight: 'bold'
          }
        }]
      };
      
      this.radarChart.setOption(option);
      
      // 先移除旧的监听器，再添加新的
      window.removeEventListener('resize', this.handleResize);
      window.addEventListener('resize', this.handleResize);
    },
    
    // 处理窗口大小变化
    handleResize() {
      if (this.radarChart) {
        this.radarChart.resize();
      }
    }
  },
};
</script>
<style scoped lang="scss">
.item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-around;
  position: relative;
  background-color: #fff;
  width: 100%;
  height: 100%;
}

.first_div {
  width: 100%;
  min-height: 1.875rem;
  height: auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 0;
  box-sizing: border-box;
}

.first_div--legacy {
  min-height: 1.875rem;
  height: auto;
  overflow: visible;
}

.item--home .first_div {
  min-height: 1.875rem;
  height: auto;
  justify-content: space-between;
  gap: 4px 12px;
}

.first_main {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  flex: 1;
  min-width: 0;
  gap: 0 4px;
}

.first_stats {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 0 16px;
  flex-shrink: 0;
  margin-right: 0.9375rem;
  max-width: 50%;
}

.meta_row {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 12px;
  min-height: 24px;
  box-sizing: border-box;
  padding: 0 0.9375rem;
}

.btn_div {
  width: auto;
  min-width: 4.75rem;
  height: auto !important;
  min-height: 22px;
  margin-left: 1.25rem;
  margin-top: 0.25rem;
  padding: 1px 8px !important;
  line-height: 1.2 !important;
  white-space: nowrap;
  box-sizing: border-box;
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  @include change_tip_size($tip_size_normal);
}

.btn_div1 {
  width: auto;
  min-width: 4rem;
  height: auto !important;
  min-height: 22px;
  padding: 1px 8px !important;
  line-height: 1.2 !important;
  white-space: nowrap;
  box-sizing: border-box;
}

/* 大号 / 特大号：略增高即可，避免裁切又不过厚 */
[data-size="3"] {
  .btn_div,
  .btn_div1 {
    min-height: 24px;
    padding: 2px 8px !important;
  }
}

[data-size="4"] {
  .btn_div,
  .btn_div1 {
    min-height: 26px;
    padding: 2px 8px !important;
  }
  .name_div {
    min-height: 1.5rem;
  }
}

html[data-wide="1"][data-size="4"] {
  .btn_div,
  .btn_div1 {
    min-height: 28px;
    padding: 2px 10px !important;
  }
}

.name_div {
  /* min-width: 20%; */
  height: auto;
  min-height: 1.5625rem;
  line-height: 1.35;
  @include change_title_size($title_size_normal);
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #444444;
  /* background-color: fuchsia; */
  text-align: left;
  margin-left: 0.9375rem;
}

.tag_div {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 95%;
  height: 30px;
  margin-left: 15px;
}

.item--home .tag_div {
  flex: 1;
  min-width: 0;
  width: auto;
  height: auto;
  min-height: 22px;
  margin-left: 0;
}

.tag_div--legacy {
  width: 95%;
  height: 30px;
  margin-left: 15px;
}

.tag_item {
  @include change_tip_size($tip_size_normal);
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  height: 22px;
  background: #fbfdff;
  border-radius: 2px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  padding: 0 4px;
}

.add_tag {
  width: 58px;
  height: 22px;
  background: #ffffff;
  border-radius: 2px;
  border: 1px dashed rgba(68, 68, 68, 0.5);
  @include change_tip_size($tip_size_normal);
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(68, 68, 68, 0.8);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.add_tag:hover {
  border: 1px dashed #5a9cf8;
  color: #5a9cf8;
}

.address {
  @include change_tip_size($tip_size_normal);
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: rgba(68, 68, 68, 0.8);
  white-space: nowrap;
}

.other_div .address {
  margin-right: 30px;
}

.visite {
  @include change_tip_size($tip_size_normal);
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: rgba(68, 68, 68, 0.8);
  white-space: nowrap;
}
.csMessage {
  @include change_tip_size($tip_size_normal);
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: rgba(68, 68, 68, 0.8);
  white-space: nowrap;
}

.other_div .csMessage {
  margin-left: 30px;
}

.other_div {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  width: 95%;
  height: 1.25rem;
  margin-left: 0.9375rem;
  padding-bottom: 5px;
  padding-top: 5px;
}

.mark_div {
  @include change_tip_size($tip_size_normal);
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.5);
  height: auto;
  line-height: 22px;
  padding: 0;
  flex-shrink: 0;
  max-width: 40%;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mark_div--legacy {
  height: 25px;
  line-height: 25px;
  padding: 0 15px;
  width: 100%;
  max-width: 100%;
  margin-bottom: 0.125rem;
}

.ai-result-content {
  max-height: 70vh;
  overflow-y: auto;
  padding: 10px;
  line-height: 1.6;
  color: #333;
}

.no-result {
  text-align: center;
  color: #999;
  font-style: italic;
}

.ai-analysis-sections {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.analysis-section {
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  padding: 20px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 15px;
  border-bottom: 2px solid #409eff;
  padding-bottom: 8px;
}

.section-content {
  font-size: 14px;
  color: #606266;
  line-height: 1.8;
  white-space: pre-wrap;
  word-break: break-word;
}

.section-content strong {
  color: #303133;
  font-weight: 600;
}

.section-content hr {
  border: none;
  border-top: 1px solid #e4e7ed;
  margin: 15px 0;
}

// 确保AI分析弹窗在最上层
::v-deep  .el-dialog__wrapper {
  z-index: 99999 !important;
}

::v-deep  .v-modal {
  z-index: 99998 !important;
}

// 分析中状态样式
.analyzing-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  min-height: 300px;
}

.analyzing-icon {
  font-size: 48px;
  color: #409eff;
  margin-bottom: 20px;
  animation: rotate 2s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.analyzing-text {
  font-size: 18px;
  color: #303133;
  font-weight: 500;
  margin-bottom: 10px;
}

.analyzing-tip {
  font-size: 14px;
  color: #909399;
  margin-bottom: 30px;
}

.analyzing-progress {
  width: 300px;
  margin-top: 20px;
}

// 客服回复分析容器样式
.cs-analysis-container {
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: flex-start;
}

.radar-chart-wrapper {
  flex-shrink: 0;
  width: 400px;
  min-width: 400px;
}

.radar-chart {
  width: 100%;
  height: 380px;
  background: #fafafa;
  border-radius: 8px;
  padding: 10px;
}

.cs-analysis-container .section-content {
  flex: 1;
  min-width: 0;
}

// 响应式布局
@media screen and (max-width: 1200px) {
  .cs-analysis-container {
    flex-direction: column;
  }
  
  .radar-chart-wrapper {
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
  }
}

html[data-compact="1"] {
  .item {
    padding: 0;
  }
  .item--home .first_div {
    min-height: 22px;
    height: auto;
    gap: 2px 8px;
  }
  .item--home .first_main {
    gap: 0 2px;
  }
  .item--home .first_stats {
    margin-right: 8px;
    max-width: 55%;
    gap: 0 10px;
  }
  .item--home .meta_row {
    padding: 0 8px;
    gap: 4px 8px;
    min-height: 20px;
  }
  .name_div {
    margin-left: 8px;
    height: auto;
    min-height: 20px;
    line-height: 1.35;
  }
  .item--home .tag_div {
    margin-left: 0;
    height: auto;
    min-height: 20px;
  }
  .tag_div--legacy {
    margin-left: 8px;
    height: 22px;
  }
  .btn_div,
  .btn_div1 {
    width: auto;
    min-width: 0;
    height: auto !important;
    min-height: 18px;
    margin-left: 6px;
    margin-top: 0;
    padding: 0 6px !important;
    line-height: 1.2 !important;
  }
  .item--home .mark_div {
    line-height: 20px;
    max-width: 35%;
  }
  .other_div {
    margin-left: 8px;
    padding-top: 2px;
    padding-bottom: 2px;
    height: auto;
  }
}
</style>
